import { render, staticRenderFns } from "./PublishStatusListLabel.vue?vue&type=template&id=aa9e5f70&scoped=true&"
import script from "./PublishStatusListLabel.vue?vue&type=script&lang=js&"
export * from "./PublishStatusListLabel.vue?vue&type=script&lang=js&"
import style0 from "./PublishStatusListLabel.vue?vue&type=style&index=0&id=aa9e5f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9e5f70",
  null
  
)

export default component.exports